export class NetworkError extends Error {
    response: Response;

    constructor(response: Response) {
        const message = `${response.status} ${response.statusText}`;
        super(message);
        this.response = response;
        this.name = 'NetworkError';
    }
}

export class MessageError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'MessageError';
    }
}

export class ConnectionAbruptedError extends Error {
    constructor() {
        super('Server closed connection unexpectedly');
        this.name = 'ServerClosedConnectionError';
    }
}

export class FatalError extends Error {
    cause: unknown;

    constructor({ cause }: { cause: unknown }) {
        super('Fatal error');
        this.name = 'FatalError';
        this.cause = cause;
    }
}

interface RequestInfo {
    url: string;
}

export class EventSourceError extends Error {
    cause: unknown;
    request: RequestInfo;

    constructor({ cause, request }: { cause: unknown; request: RequestInfo }) {
        const message = cause instanceof Error ? cause.message : `Unknown error`;
        super(message);
        this.name = 'EventSourceError';
        this.cause = cause;
        this.request = request;
    }
}
